export default __webpack_public_path__ + "static/media/_DSC7381.f3216698.jpg";